import React from 'react';
import { Button } from '../ui/button';
import Icon from '../ui/icon';
import { cn } from '../../lib/utils';
import { useScrollDirection } from '../../hooks/useScrollDirection';
import { getGreetingMessage } from '../../lib/greeting';
import { useAuth } from '../../contexts/AuthContext';

interface HeaderProps {
  title: string;
  outletname?: string;
  user?: {
    name: string;
    avatar?: string;
    badge?: string;
  };
  onThemeToggle?: () => void;
  theme?: 'light' | 'dark';
  className?: string;
}

const Header: React.FC<HeaderProps> = ({
  title,
  outletname,
  user,
  onThemeToggle,
  theme = 'light',
  className
}) => {
  const { scrollDirection, isScrolling } = useScrollDirection();
  const { user: authUser } = useAuth();
  
  return (
    <header className={cn(
      "fixed top-0 left-0 right-0 z-50 w-full border-b bg-background transition-transform duration-300 ease-in-out",
      scrollDirection === 'down' && isScrolling ? '-translate-y-full' : 'translate-y-0',
      className
    )}>
      <div className="max-w-4xl mx-auto px-4 flex h-16 items-center justify-between">
        {/* Left side - Logo & Title */}
        <div className="flex items-center gap-3">
          <div className="w-full flex items-center gap-2">
          <span 
            className="text-md inline-block cursor-pointer hover:scale-110 transition-transform duration-200"
            style={{ animation: 'wave 2s ease-in-out infinite' }}
          >
            👋
          </span> {(user || authUser) && (
            <div className="flex flex-col">
              <span className="text-lg flex items-center gap-2 line-clamp-1">
                {getGreetingMessage()}{authUser?.contact_person || user?.name ? ` ${authUser?.contact_person || user?.name}!` : 'Bạn!'} 
              </span>
            </div>
            )}
          </div>
        </div>

        {/* Right side - Actions */}
        <div className="flex items-center gap-2">
          <Button 
            variant="ghost"
            size="icon"
            className="h-10 w-10 relative"
          >
            <Icon name={ "bell" } size={20} />
            <span className="absolute right-2.5 top-2 w-1.5 h-1.5 rounded-full bg-destructive"/>
          </Button>
          {onThemeToggle && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onThemeToggle}
              className="h-9 w-9"
            >
              <Icon 
                name={theme === 'light' ? 'moon' : 'sun'} 
                size={18}
                className="h-5 w-5"
              />
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
